module.exports = __webpack_public_path__ + "img/AM_Banner.22dfbe12.webp";